import { KYMW7200Model } from '../kymw7200.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { SearchOperationGoodsListModel } from '../vo/search-operation-goods-list.model';

/**
 * 運営商品一覧情報取得
 *
 * @export 
 * @class GetOperationGodsListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOperationGoodsListService extends PlessJsonResponderSub<any> {
  private vo = new SearchOperationGoodsListModel();
  private calbak: () => void;

  // 処理に使用するModel
  private model: KYMW7200Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOperationGodsListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetOperationGoodsList: {
          condition: {
            DeliveryDiv: this.vo.deliveryDiv,
            OrderNum: this.vo.orderNum,
            OrderCatalog: this.vo.orderCatalog,
            PlanningManagementDiv: this.vo.planningManagementDiv,
            PlanningManagementDetailDiv: this.vo.planningManagementDetailDiv,
            GoodsName: this.vo.goodsName,
            StandardName: this.vo.standardName,
            Page: this.vo.page,
          },
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetOperationGodsListService
   */
  execute(model: KYMW7200Model, vo: SearchOperationGoodsListModel, f: () => void = null): void {
    this.model = model;
    this.vo = vo;
    this.calbak = f;
    this.send('getOperationGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOperationGodsListService
   */
  success(data: any): void {
    this.model.setDisplayResult(data);
    if (this.calbak) this.calbak();
  }

  /**
  * 業務エラー時のメソッド
  * @param errList サーバ受信データ
  * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
  */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
